exports.type_list = [
  {
    label: '整型',
    value: 'int'
  },
  {
    label: '字符型',
    value: 'string'
  },
  {
    label: '浮点型',
    value: 'float'
  },
  {
    label: '布尔型',
    value: 'bool'
  },
  {
    label: '枚举型',
    value: 'enum'
  }
]